import { useIntl } from 'react-intl'

import { BidInput } from '@b-stock/fe-core/bstock-next/components'
import { Tooltip } from '@b-stock/fe-core/bstock-react'

import { FormInputWrapper } from '../ActionForm/ui'
import type { useAuctionActionForm } from './useAuctionActionForm'

const ns = 'Listings.ListView.actionCell.auction'

/**
 * The amount to bid, wherever there is room to enter it.
 *
 * Inline in the wide panel and in an overlay for the narrow panel.
 */
export const BidAmountField = ({
  form,
}: {
  form: ReturnType<typeof useAuctionActionForm>
}) => {
  const { formatMessage } = useIntl()

  const {
    bidBasis,
    bidPrecision,
    currency,
    error,
    inputWrapperRef,
    onChangeValue,
    onKeyDownValue,
    placeholder,
    touched,
    value,
  } = form

  return (
    <FormInputWrapper ref={inputWrapperRef}>
      {touched && !!error && (
        // oxlint-disable-next-line react/refs
        <Tooltip referenceElement={inputWrapperRef.current}>
          {formatMessage({ id: `${ns}.error.bidBelowMinimum` })}
        </Tooltip>
      )}
      <BidInput
        bidBasis={bidBasis}
        bidPrecision={bidPrecision}
        currencyCode={currency}
        error={touched && !!error}
        handleValueChange={onChangeValue}
        label=""
        onKeyDown={(e) => onKeyDownValue(e.key)}
        placeholder={placeholder}
        pricingStrategy="AUCTION"
        storedValue={value || null}
      />
    </FormInputWrapper>
  )
}
